import React from 'react';
import PropTypes from 'prop-types';
import { has } from 'lodash';
import { gettext } from '@eb/i18n';

import { IconButton } from '@eb/eds-icon-button';
import { InputField } from '@eb/eds-input-field';
import { PencilChunky } from '@eb/eds-iconography';

import { ofuscateEmail } from '../utils/security';

import './staticEmailField.scss';

export default class StaticEmailField extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string.isRequired,
        onEmailEdit: PropTypes.func,
        clearNotification: PropTypes.func,
    };

    _handleEmailEdit = () => {
        const {
            onEmailEdit,
            clearNotification,
            formErrors,
            onEmailMismatch,
        } = this.props;

        clearNotification && clearNotification();

        onEmailEdit && onEmailEdit();

        if (formErrors && has(formErrors, 'confirmEmail')) {
            onEmailMismatch();
        }
    };

    render() {
        const { onEmailEdit, shouldRevealEmail } = this.props;
        let { email } = this.props;
        let editButton = null;

        if (!shouldRevealEmail) {
            email = ofuscateEmail({ email });
        }
        if (onEmailEdit) {
            editButton = (
                <IconButton
                    iconType={<PencilChunky />}
                    onClick={this._handleEmailEdit}
                    title={gettext('Edit Email')}
                />
            );
        }

        return (
            <div className="eds-l-mar-top-5 eds-l-mar-bot-4">
                <div className="static-email-field__button">
                    <InputField
                        id="email"
                        label={gettext('Email address')}
                        suffix={editButton}
                        placeholder={email}
                        disabled={true}
                        hasMinAsideSpacing={true}
                        style="static"
                    />
                </div>
            </div>
        );
    }
}
